import { Avatar, Tooltip, useTheme } from "@mui/material";

const rescaleBbox = (anchor, currentViewport) => {
  const sourceWidth = anchor.viewport?.w || currentViewport.w;
  const sourceHeight = anchor.viewport?.h || currentViewport.h;
  const xScale = currentViewport.w / sourceWidth;
  const yScale = currentViewport.h / sourceHeight;
  return {
    x: anchor.bbox.x * xScale,
    y: anchor.bbox.y * yScale,
    w: anchor.bbox.w * xScale,
    h: anchor.bbox.h * yScale,
  };
};

const DECISION_PIN_COLOR = {
  addressed: (palette) => palette.backgroundGray.dark,
  carried_over: (palette) => palette.warning.main,
  flagged_obsolete: (palette) => palette.warning.dark,
  needs_product_decision: (palette) => palette.error.main,
  deferred_to_build: (palette) => palette.info.main,
};

const DECISION_LABEL = {
  addressed: "Addressed",
  carried_over: "Carried over — re-verify",
  flagged_obsolete: "Possibly obsolete — confirm",
  needs_product_decision: "Needs your decision",
  deferred_to_build: "Recorded for build phase",
};

const resolvePinColor = (comment, palette) => {
  const decision = comment.mockupResolution?.decision;
  const decisionColor = decision && DECISION_PIN_COLOR[decision];
  if (decisionColor) {
    return decisionColor(palette);
  }
  return comment.status === "resolved" ? palette.backgroundGray.dark : palette.primary.main;
};

const buildTooltipText = (comment) => {
  const decisionLabel = DECISION_LABEL[comment.mockupResolution?.decision];
  const commentText = comment.thread?.[0]?.text?.slice(0, 80);
  return [decisionLabel, commentText].filter(Boolean).join(" — ") || "Comment";
};

const CommentPin = ({ comment, index, currentViewport, onSelect }) => {
  const { palette } = useTheme();
  const rect = rescaleBbox(comment.anchor, currentViewport);
  const centerX = rect.x + rect.w / 2;
  const centerY = rect.y + rect.h / 2;

  return (
    <Tooltip title={buildTooltipText(comment)} placement="top">
      <Avatar
        onClick={() => onSelect(comment)}
        sx={{
          position: "absolute",
          left: centerX - 14,
          top: centerY - 14,
          width: 28,
          height: 28,
          fontSize: 14,
          cursor: "pointer",
          bgcolor: resolvePinColor(comment, palette),
          color: palette.common.white,
          border: `2px solid ${palette.common.white}`,
          boxShadow: 1,
          zIndex: 1100,
        }}
      >
        {index + 1}
      </Avatar>
    </Tooltip>
  );
};

const CommentPins = ({ comments, currentViewport, onSelect }) => (
  <>
    {comments.map((comment, index) => (
      <CommentPin
        key={comment.id}
        comment={comment}
        index={index}
        currentViewport={currentViewport}
        onSelect={onSelect}
      />
    ))}
  </>
);

export default CommentPins;
